import { UpcomingPage } from '../types/content';

export const upcomingPages: UpcomingPage[] = [
  {
    slug: 'projets',
    title: 'Projets',
    lead: 'Le portfolio complet, classé par univers, avec des fiches projets documentées comme des pièces d’ingénierie.',
    sections: [
      'Navigation par univers : spectacle, sculpture, parcours lumineux, événementiel',
      'Cartouche synthétique : client, scénographe, lieu, année',
      'Données techniques : matériaux et machines mobilisées',
      'Contraintes logistiques résolues : démontage, légèreté, M1, calage camion',
      'Médiathèque : plans 3D, vidéos d’usinage, photos d’atelier et rendu in situ',
    ],
  },
  {
    slug: 'atelier',
    title: 'L’Atelier & Bureau d’études',
    lead: 'Nos cinq pôles de fabrication, notre parc machines et l’accompagnement technique en amont.',
    sections: [
      'Présentation des 5 pôles de fabrication et de leurs machines',
      'Modélisation 3D et accompagnement technique en amont',
      'Formats acceptés : STEP, OBJ, plans d’exécution',
    ],
  },
  {
    slug: 'contact',
    title: 'Contact & Devis',
    lead: 'Un formulaire complet pour cadrer votre projet, et toutes les infos pour livrer ou enlever à l’atelier.',
    sections: [
      'Sélecteur de contraintes : dimensions, usage intérieur / extérieur',
      'Date de livraison souhaitée',
      'Import de fichiers 3D et PDF',
      'Localisation de l’atelier et accès poids lourds',
    ],
  },
];
